'use client';

import { motion } from 'framer-motion';
import type { PostHeroProps } from '@routeroyal/theme-core';

/**
 * Stone Investment Post Hero
 * 
 * Minimal hero section for news/blog listing
 */
export function StoneInvestmentPostHero({ 
  title, 
  subtitle,
  showSearch: _showSearch = false,
  onSearch: _onSearch,
  searchPlaceholder: _searchPlaceholder,
  className = '',
}: PostHeroProps) {
  return (
    <section className={`py-20 lg:py-28 bg-[var(--color-background)] ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-px bg-[var(--color-text)]" />
            <span 
              className="text-xs tracking-[0.3em] uppercase text-[var(--color-text-muted)]"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              News & Updates
            </span>
          </div>
          
          <h1 
            className="text-4xl lg:text-5xl xl:text-6xl text-[var(--color-text)] tracking-[-0.02em] mb-6"
            style={{ 
              fontFamily: "'Cormorant Garamond', 'Georgia', serif",
              fontWeight: 300,
            }}
          >
            {title}
          </h1>
          
          {subtitle && (
            <p 
              className="text-[var(--color-text-muted)] text-base lg:text-lg max-w-2xl"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
